/**
 * 설정 - 관리자 설정
 */
import React from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";

import { fn_auth_pop } from "function/FnBodyLayer";
import { Switcher } from "components/ui/Switcher";
import { Button } from "components/ui/Button";
import { fn_bridge_shopinfo_set } from "function/FnPosBridge";
import SettingDefaultLeftView from "./components/layouts/SettingDefaultLeftView";

const BoxTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  border-bottom: 2px solid #000;
  position: relative;
  padding-bottom: 10px;
`;

const BoxTitleText = styled.h4`
  font-size: 21px !important;
  font-weight: 700 !important;
  line-height: normal !important;
`;

const BoxList = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  margin-left: 21px;
  border-bottom: 1px solid #b2b3b4;
`;

const BoxListContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const BoxListTitle = styled.strong`
  font-weight: bold;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
`;

const BoxListSubTitle = styled.p`
  color: #8c8c8c;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding-top: 4px;
`;

const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 85%;
`;

const AuthTitleBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const AuthDescription = styled.p`
  color: #8a9198;
  padding-top: 8px;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
`;

const AuthBtnWrap = styled.div`
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
`;

const InnerContainer = styled.div`
  height: 100%;
  padding: 20px !important;
`;

const SwitcherList = ({ title, subTitle, children }) => {
  return (
    <>
      <BoxList>
        <BoxListContent>
          <BoxListTitle>{title}</BoxListTitle>
          <BoxListSubTitle>{subTitle}</BoxListSubTitle>
        </BoxListContent>
        {children}
      </BoxList>
    </>
  );
};

const SettingDefaultManagerSetView = ({ rootStore }) => {
  const settingStore = rootStore.settingStore;
  const layerStore = rootStore.layerStore;

  settingStore.setSettingUseMenu("manager_setting");
  settingStore.setSettingView(false);

  // 매출 분석 페이지 스위치 변경 처리
  const handleSalePageChange = e => {
    const { id } = e.target;

    rootStore.settingStore.setManagerSetting(id, e.target.checked ? "Y" : "N");
    fn_bridge_shopinfo_set(rootStore);
  };

  // 관리자 설정 페이지 렌더링
  const renderContent = () => {
    const isAuth =
      layerStore.getManagerAuthView.manager === "Y" ||
      rootStore.layerStore.getManagerAuthView.auth === "Y" ||
      localStorage.getItem("auth") === "Y";
    if (isAuth) {
      return (
        <>
          <BoxTitle>
            <BoxTitleText>[배달앱 매출 통계] 설정</BoxTitleText>
          </BoxTitle>
          <SwitcherList title="메뉴 사용 설정" subTitle="메뉴 노출 여부 설정">
            <Switcher
              id="saleMenuShow"
              switcherColor="primary"
              size="lg"
              checked={settingStore.getManagerSetting?.saleMenuShow === "Y"}
              onChange={handleSalePageChange}
              showLabel={true}
              onLabel={"사용"}
              offLabel={"미사용"}
            />
          </SwitcherList>
          <SwitcherList title=" 관리자 인증 사용 설정" subTitle="페이지 진입시 관리자 인증 사용 설정">
            <Switcher
              id="salePage"
              switcherColor="primary"
              size="lg"
              checked={settingStore.getManagerSetting?.salePage === "Y"}
              onChange={handleSalePageChange}
              showLabel={true}
              onLabel={"사용"}
              offLabel={"미사용"}
            />
          </SwitcherList>
        </>
      );
    }

    return (
      <AuthContainer>
        <AuthTitleBox>
          <img src={require("static-file/images/bg_address_none.png")} alt="관리자 인증" />
          <p className="color-black text-center text-2xl font-bold">관리자 인증이 필요합니다</p>
        </AuthTitleBox>
        <AuthDescription>[인증하기] 버튼을 통해 인증을 진행해주세요.</AuthDescription>
        <AuthBtnWrap>
          <Button fullWidth={true} onClick={() => fn_auth_pop(rootStore)}>
            인증하기
          </Button>
        </AuthBtnWrap>
      </AuthContainer>
    );
  };

  return (
    <>
      <div className="article_setting">
        {/*왼쪽 메뉴 */}
        <SettingDefaultLeftView rootStore={rootStore} />
        <div className="section_content">
          <h3>관리자 설정</h3>
          <div className="scroll">
            <InnerContainer className="inner manager">{renderContent()}</InnerContainer>
            <div className="close">
              <Link to="/">
                <button type="button">
                  <span>페이지 닫기</span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default inject("rootStore")(observer(SettingDefaultManagerSetView));
